import p3_1 from "./p3-1.jpg";
import p3_2 from "./p3-2.jpg";
import p3_3 from "./p3-3.jpg";
import p3_4 from "./p3-4.jpg";
import p3_5 from "./p3-5.jpg";
import p3_6 from "./p3-6.jpg";
import p3_7 from "./p3-7.jpg";
import p3_8 from "./p3-8.jpg";
import p3_9 from "./p3-9.jpg";
import p3_10 from "./p3-10.jpg";
import p3_11 from "./p3-11.jpg";
import p3_12 from "./p3-12.jpg";
import p3_13 from "./p3-13.jpg";
import p3_14 from "./p3-14.jpg";
import p3_15 from "./p3-15.jpg";
import p3_16 from "./p3-16.jpg";
import p3_17 from "./p3-17.jpg";
import p3_18 from "./p3-18.jpg";
import p3_19 from "./p3-19.jpg";
import p3_20 from "./p3-20.jpg";
import p3_21 from "./p3-21.jpg";
import p3_22 from "./p3-22.jpg";
import p3_23 from "./p3-23.jpg";
import p3_24 from "./p3-24.jpg";
import p3_25 from "./p3-25.jpg";
import p3_26 from "./p3-26.jpg";
import p3_27 from "./p3-27.jpg";
import p3_28 from "./p3-28.jpg";
import p3_29 from "./p3-29.jpg";
import p3_30 from "./p3-30.jpg";
import p3_31 from "./p3-31.jpg";
import p3_32 from "./p3-32.jpg";
import p3Fp1np3d from "./p3-fp-1np-3d.jpg";
import p3Fp1np2d from "./p3-fp-1np-2d.jpg";
import p3Fp2np3d from "./p3-fp-2np-3d.jpg";
import p3Fp2np2d from "./p3-fp-2np-2d.jpg";

export const pozden3Images = [
  p3_1, p3_2, p3_3, p3_4, p3_5, p3_6, p3_7, p3_8, p3_9, p3_10,
  p3_11, p3_12, p3_13, p3_14, p3_15, p3_16, p3_17, p3_18, p3_19, p3_20,
  p3_21, p3_22, p3_23, p3_24, p3_25, p3_26, p3_27, p3_28, p3_29, p3_30,
  p3_31, p3_32,
];

export const pozden3FloorPlans = [
  { image: p3Fp1np3d, label: "1. NP – 3D" },
  { image: p3Fp1np2d, label: "1. NP – 2D" },
  { image: p3Fp2np3d, label: "2. NP – 3D" },
  { image: p3Fp2np2d, label: "2. NP – 2D" },
];
